import {DataTable} from "../DataTable/DataTable";
import {useTranslation} from "react-i18next";
import {usePagination} from "../DataTable/usePagination";
import {getColumnFilterProps} from "../DataTable/useDataTableFilter";
import {useDataTableSorter} from "../DataTable/useDataTableSorter";
import {EntityDataTableProps} from "../EntityDataTable/EntityDataTable";
import {MouseEvent, useCallback, useMemo} from "react";
import {DataTableColumn} from "mantine-datatable";
import {sortBy} from "lodash";
import {EntityActionGroup} from "../../group/EntityActionGroup/EntityActionGroup";
import {ServiceTypeModeEntity} from "@ots-frontend/ots-data";
import {useServiceTypeModeDataTableFilter} from "./useServiceTypeModeDataTableFilter";
import {useServiceTypeModeMutation} from "../../../hooks/useServiceTypeModeMutation";

const EMPTY_ARRAY: ServiceTypeModeEntity[] = []

export type ServiceEventTypeDataTableProps = EntityDataTableProps<ServiceTypeModeEntity>

export const ServiceTypeModeDataTable = (props: ServiceEventTypeDataTableProps) => {
  const {
    records: modes = EMPTY_ARRAY,
    recordsPerPageOptions,
    ...rest
  } = props

  const {t} = useTranslation(["common"]);

  const {filteredRecords, filterConfig} = useServiceTypeModeDataTableFilter({
    records: modes
  })

  const sortConfig = useMemo(() => {
    return {
      "mode": {
        sortAll: (records, columnAccessor) => {
          return sortBy(records, [function (record) {
            return record.mode?.toLowerCase()
          }])
        }
      },
    }
  }, [])

  const {
    sortedRecords,
    sortStatus,
    onSortStatusChange,
  } = useDataTableSorter({
    records: filteredRecords,
    sortStatus: {columnAccessor: 'mode', direction: 'asc'},
    sortConfig: sortConfig,
  })

  const pagination = usePagination({
    data: sortedRecords,
    recordsPerPageOptions: recordsPerPageOptions,
  });

  const {
    deleteServiceTypeMode,
  } = useServiceTypeModeMutation()

  const onDeleteActionClick = useCallback((e: MouseEvent<HTMLButtonElement>, record: ServiceTypeModeEntity) => {
    e.stopPropagation()
    deleteServiceTypeMode(record.id, undefined)
  }, [deleteServiceTypeMode])

  const columns = useMemo(() => {
    const values: DataTableColumn<ServiceTypeModeEntity>[] = [
      {
        ...getColumnFilterProps(filterConfig, "mode"),
        title: t("common.entity.servicetypemode.table.column.mode", "Mode"),
        accessor: 'mode',
        width: 400,
        sortable: true,
      },
      {
        title: '',
        accessor: "actions",
        width: 100,
        textAlignment: 'right',
        render: (company) => (
            <EntityActionGroup
                permissionPrefix={"servicetype"}
                view={false}
                edit={false}
                delete={true}
                onDeleteActionClick={(e) => onDeleteActionClick(e, company)}
            />
        )
      }
    ]

    return values
  }, [filterConfig, onDeleteActionClick, t])

  return (
      <DataTable
          {...rest}
          {...(pagination ?? {})}
          sortStatus={sortStatus}
          onSortStatusChange={onSortStatusChange}
          columns={columns}
      />
  )
}
